module.exports = __webpack_public_path__ + "img/logo.86659355.png";